//
//
//
//
//
//
//

export default {
  name: 'uni-number-box',
  props: {
    value: {
      type: Number,
      default: 1
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    step: {
      type: Number,
      default: 1
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      inputValue: this.value
    }
  },
  computed: {
    disableSubtract() {
      return this.inputValue <= this.min
    },
    disableAdd() {
      return this.inputValue >= this.max
    }
  },
  watch: {
    value(val) {
      this.inputValue = val;
    },
    inputValue(val) {
      this.$emit('change', val);
    }
  },
  methods: {
    _calcValue(type) {
      if (this.disabled) {
        return
      }
      const scale = this._getDecimalScale()
      let value = this.inputValue * scale
      let step = this.step * scale
      if (type === 'subtract') {
        value -= step
      } else if (type === 'add') {
        value += step
      }
      if (value < this.min || value > this.max) {
        return
      }
      this.inputValue = value / scale;
    },
    _getDecimalScale() {
      let scale = 1
      // 浮点型
      if (~~this.step !== this.step) {
        scale = Math.pow(10, (this.step + '').split('.')[1].length)
      }
      return scale
    },
    _onBlur(event) {
      let value = event.detail.value
      if (!value) {
        this.inputValue = 0
        return
      }
      value = +value;
      if (value > this.max) {
        value = this.max
      } else if (value < this.min) {
        value = this.min
      }
      this.inputValue = value
    }
  }
}
